/**
 * Recomendados en páginas marketplace / PDV — perfil desde cookie oleum_ctx.
 * Sin perfil: muestra productos con data-fallback (metafield favorito).
 */
(function () {
  'use strict';

  function productIdKey(id) {
    return String(id);
  }

  function buildIndex(items) {
    var idToEl = {};
    var handleToEl = {};
    items.forEach(function (el) {
      var id = productIdKey(el.getAttribute('data-product-id'));
      var handle = (el.getAttribute('data-product-handle') || '').trim();
      if (id) idToEl[id] = el;
      if (handle) handleToEl[handle] = el;
    });
    return { idToEl: idToEl, handleToEl: handleToEl };
  }

  function findItem(row, index) {
    var p = row && row.product;
    if (!p) return null;
    return index.idToEl[productIdKey(p.id)] || (p.handle ? index.handleToEl[p.handle] : null) || null;
  }

  function initSection(section) {
    if (!section || section.getAttribute('data-oleum-page-rec-init')) return;
    section.setAttribute('data-oleum-page-rec-init', '1');

    var grid = section.querySelector('[data-oleum-page-rec-grid]');
    if (!grid) return;

    var limit = parseInt(section.getAttribute('data-products-limit') || '6', 10);
    var items = Array.prototype.slice.call(grid.querySelectorAll('[data-oleum-page-rec-item]'));
    if (!items.length) return;

    var Engine = window.OleumProfileEngine;
    var Recommender = window.OleumRecommender;
    var ctx = Engine && Engine.loadUserContext ? Engine.loadUserContext() : null;
    var catalog = window.OleumProductCatalog || [];
    var index = buildIndex(items);
    var toShow = [];

    if (ctx && Recommender && catalog.length) {
      var ranked = Recommender.rankProducts(catalog, ctx);
      ranked.forEach(function (row) {
        if (toShow.length >= limit) return;
        var el = findItem(row, index);
        if (el) toShow.push(el);
      });

      var explorar = section.querySelector('[data-oleum-page-rec-explorar]');
      if (explorar && ctx.route) {
        explorar.href = ctx.route;
      }
    }

    if (!toShow.length) {
      toShow = items
        .filter(function (el) {
          return el.getAttribute('data-fallback') === 'true';
        })
        .slice(0, limit);
    }

    if (!toShow.length) {
      toShow = items.slice(0, limit);
    }

    items.forEach(function (el) {
      el.hidden = true;
    });
    toShow.forEach(function (el) {
      el.hidden = false;
      grid.appendChild(el);
    });

    if (toShow.length && window.matchMedia('(min-width: 750px)').matches) {
      grid.classList.add('favoritos-grid--carousel');
    }

    document.dispatchEvent(
      new CustomEvent('oleum:page-recommended:ready', { detail: { section: section } })
    );
  }

  function initAll() {
    document.querySelectorAll('[data-oleum-page-recommended]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-oleum-page-recommended]');
    if (section) initSection(section);
  });
})();
